import React, { useEffect, useState } from "react";
import {useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {toast } from 'react-toastify';
import {setLogin} from "../features/authSlice";
import Homeheader from "../components/Homeheader";
import style from "./Login.module.css";
import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";

function Login() {
  const dispatch = useDispatch();
  const { token, tokenVerified } = useSelector((state) => state.auth); // Add this
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    if (token && tokenVerified) {
      navigate("/");
    }
  }, [token, tokenVerified, navigate]); // Update this
  // useEffect(() => {
  //   const user =   JSON.parse(localStorage.getItem("user")) 
  //   const token =  localStorage.getItem("token") 
  //   const isAuthenticated = user && token;
  //   if (isAuthenticated) {
  //     dispatch(setLogin({token,user})); // Dispatch login action with user info
  //     navigate("/"); // Redirect to the home page
  //   }
  // }, [dispatch, navigate]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    // dispatch(setLogin(username, password));
    // setUsername("");
    // setPassword("");
    try {
      setIsLoading(true);
      // "https://api.up2smart.com:5001"
      // const response = await fetch("https://192.168.0.102:5001/v1/login", {
      const response = await fetch("https://api.up2smart.com:5001/v1/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, password }),
      });
      // console.log(response);
      if (!response.ok) {
        if (response.status === 500) {
          throw new Error("Server error, please try again later");
        }
        if (response.status === 401) {  
          throw new Error("Invalid username or password");
        }
      }
  
      const {token,user} = await response.json(); // Parse the JSON response
      dispatch(setLogin({token,user})); // Dispatch login action with user info
      // console.log(token,user);
      // dispatch(setLogin(userInfo.username, userInfo.role)); // Dispatch login action with user info
      toast.success("Login successful");
      navigate("/"); // Redirect to the home page
    } catch (error) {
      console.error("Login failed:", error.message);
      toast.error(error.message); // Show an error message to the user
      // alert(error.message); // Show an error message to the user
    } finally {
      setIsLoading(false);
      setUsername("");
      setPassword("");
    }
  };

  return (
    <>
    <LoadingOverlay isVisible={isLoading} message={"Please wait..."} >
        <MoonLoader color="#00BFFF" size={50} />
      </LoadingOverlay>
      <Homeheader />
      <div className={style.loginContainer}>
        <div className={style.loginBox}>
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <div className={style.inputGroup}>
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                required
              />
            </div>
            <div className={style.inputGroup}>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
            </div>
            <button type="submit" className={style.loginButton}>
              Login
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
